// extracted by mini-css-extract-plugin
export default {"card":"print-styles_card__q8SgB","htTable":"print-styles_htTable__vVU6S","hallticketBody":"print-styles_hallticketBody__UA1mP"};